export interface UiState {
  isDarkTheme: boolean;
  isNavbarHiddenByScroll: boolean;
  isShadowVisibleByScroll: boolean;
}
